export default {
    cancelText: 'Cancel',
};
